import { render, staticRenderFns } from "./InputRadioButton.vue?vue&type=template&id=06173662"
import script from "./InputRadioButton.ts?vue&type=script&lang=ts&external"
export * from "./InputRadioButton.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports